module.exports = __webpack_public_path__ + "static/media/home2-slider-3.95dee678.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home2-slider-3.jpg
// module id = 1150
// module chunks = 33